import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { LoginService } from './login.service';
import { CoreModule } from '../core/core.module';
import { AnonymousUserLoginComponent } from './anonymous-user-login/anonymous-user-login.component';
import { RegisteredUserLoginComponent } from './registered-user-login/registered-user-login.component';
import { SharedModule } from '../shared/shared.module';
import { ForgottenUsernamePasswordComponent } from './forgotten-username-password/forgotten-username-password.component';

@NgModule({
    declarations: [LoginComponent, AnonymousUserLoginComponent, RegisteredUserLoginComponent, ForgottenUsernamePasswordComponent],
    imports: [
        CommonModule,
        LoginRoutingModule,
        CoreModule,
        SharedModule
    ],
    providers: [LoginService]
})
export class LoginModule { }
